import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
const criteria = [{
  yes: 'Tu hijo tiene TEA con comunicación limitada o no verbal',
  no: 'Buscás una cura o solución mágica'
}, {
  yes: 'Las crisis de comunicación se repiten en casa',
  no: 'No querés imprimir ni preparar materiales'
}, {
  yes: 'Querés una guía clara y visual paso a paso',
  no: 'No estás dispuesto/a a dedicar 15 min diarios'
}, {
  yes: 'Querés que la escuela entienda a tu hijo',
  no: 'Tu hijo ya tiene comunicación verbal fluida'
}, {
  yes: 'Necesitás herramientas para salir tranquilo/a',
  no: 'Esperás resultados sin participación activa'
}, {
  yes: 'Querés llevar información concreta al terapeuta',
  no: 'Buscás solo teoría sin herramientas prácticas'
}];
export function IsThisForYou() {
  return <section className="py-12 md:py-16 bg-cream" data-id="element-148">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-149">
        <div className="text-center mb-8" data-id="element-150">
          <h2 className="text-3xl md:text-5xl font-bold text-teal-900" data-id="element-151">
            ¿ESTE SISTEMA ES PARA VOS?
          </h2>
        </div>

        <div className="rounded-3xl border border-stone-200 overflow-hidden shadow-sm" data-id="element-152">
          <table className="w-full table-fixed border-collapse" data-id="element-153">
            <thead data-id="element-154">
              <tr data-id="element-155">
                <th className="w-1/2 bg-teal-50 border-b border-teal-100/70 px-3 py-4 sm:px-5" data-id="element-156">
                  <div className="flex items-center justify-center gap-2" data-id="element-157">
                    <CheckCircle2 className="w-5 h-5 text-teal-600 flex-shrink-0" data-id="element-158" />
                    <span className="text-sm sm:text-lg font-bold text-teal-900" data-id="element-159">
                      SÍ ES PARA VOS
                    </span>
                  </div>
                </th>
                <th className="w-1/2 bg-coral-50 border-b border-l border-coral-100/70 px-3 py-4 sm:px-5" data-id="element-160">
                  <div className="flex items-center justify-center gap-2" data-id="element-161">
                    <XCircle className="w-5 h-5 text-coral-500 flex-shrink-0" data-id="element-162" />
                    <span className="text-sm sm:text-lg font-bold text-coral-900" data-id="element-163">
                      NO ES PARA VOS
                    </span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-164">
              {criteria.map((c, i) => <tr key={i} className="align-top" data-id="element-165">
                  <td className="bg-teal-50/40 border-b border-teal-100/50 px-3 py-3 sm:px-5 sm:py-4" data-id="element-166">
                    <div className="flex items-start gap-2" data-id="element-167">
                      <CheckCircle2 className="w-4 h-4 sm:w-5 sm:h-5 text-teal-500 flex-shrink-0 mt-0.5" data-id="element-168" />
                      <span className="text-xs sm:text-base text-teal-900 font-medium leading-snug" data-id="element-169">
                        {c.yes}
                      </span>
                    </div>
                  </td>
                  <td className="bg-coral-50/40 border-b border-l border-coral-100/50 px-3 py-3 sm:px-5 sm:py-4" data-id="element-170">
                    <div className="flex items-start gap-2" data-id="element-171">
                      <XCircle className="w-4 h-4 sm:w-5 sm:h-5 text-coral-400 flex-shrink-0 mt-0.5" data-id="element-172" />
                      <span className="text-xs sm:text-base text-coral-900 leading-snug" data-id="element-173">
                        {c.no}
                      </span>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}